import React, { useContext } from "react";
import { RESOURCE_NAME } from "common/authorization";
import { FEATURE_FLAG_NAME } from "common/constants";
import { AuthContext } from "../../Authorization/AuthContext";
import { MenuItems, SubTabMenu } from "../SubTabMenu";
import PublicUsers from "./PublicUsers";
import Team from "./Team";

export const Users = () => {
  const { authorized, isFeatureEnabled } = useContext(AuthContext);
  const canViewTeamSettings = authorized({
    resource: RESOURCE_NAME.USER,
    permission: "list",
  });
  const canViewPublicUsers =
    authorized({
      resource: RESOURCE_NAME.PUBLIC_USER,
      permission: "list",
    }) && isFeatureEnabled(FEATURE_FLAG_NAME.PUBLIC_USERS);

  const menuItems: MenuItems = [
    {
      name: "Team",
      path: "/team",
      restrict: !canViewTeamSettings,
      component: Team,
    },
    {
      name: "Public website guests",
      path: "/public",
      restrict: !canViewPublicUsers,
      component: PublicUsers,
    },
  ];

  return <SubTabMenu menuItems={menuItems} />;
};
